var map = {
	"./CommonHandlers/SubscribeToListExtended": 73920,
	"./CommonHandlers/SubscribeToListExtended.ts": 73920,
	"./ConatctUsSendDataToApiExtended": 97109,
	"./ConatctUsSendDataToApiExtended.ts": 97109,
	"./DocumentSearch/DocumentSearchHandler": 89638,
	"./DocumentSearch/DocumentSearchHandler.tsx": 89638,
	"./UsLoadSettings": 12758,
	"./UsLoadSettings.ts": 12758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36594;